var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _g3, _path38, _path39, _path40, _g4, _path41, _path42, _g5, _path43, _path44, _g6, _path45, _path46, _g7, _path47, _path48, _g8, _path49, _use, _g9, _path50, _path51, _g10, _path52, _use2, _g11, _path53, _use3, _g12, _path54, _path55, _g13, _path56, _path57, _path58, _g14, _path59, _path60, _g15, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g16, _path70, _path71, _g17, _path72, _g18, _path73, _rect, _circle, _path74, _path75, _path76;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M136.7 252.7c-2.9-5.6-4-9.6-4-10.5 0-1.9 4-3 4-3 6.2-3.3 35.5 1.5 48.7 3.7a151 151 0 0 0 22.4 2.2s1.8-1.5 4-3.3 12.5-14 16.5-15 7.7 1.5 7.7 1.5 6.6 4 5.5 4.7-17.2 14.7-21.3 17.3-12.4 1.5-19.8 3c-6.3 1.2-32 2.7-37.8 3.2a21 21 0 0 1-13.2-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M281.7 285.4a8 8 0 0 1 6.9-4.2h66.7s4.8 0 3.3 9.2-21.2 65-26 82-5.7 52.5-5.7 52.5h-80s6.3-85.2 34.7-139.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M132.6 242.2v.2zm4.1 10.5a48 48 0 0 1-4-9.7 48 48 0 0 0 4 9.7m-4-10.2v.2zm0 .2v.3zm4 10a92 92 0 0 0 13.9 19.6c13.2 14.3 51.4 51.7 55 54.3s2.6 9.9 0 17.2-12.1 18-11.8 29.7 4 29.7 3.7 33.4-9.5 16.2-9.5 16.2h94.7s-11.8-15-11.8-20.2 16.2-70.8 16.9-75.6-2.2-8-8-8.4-28.3-5.2-29.4-8.8 5.8-17.7 5.8-17.7l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4-15-4.7-18.8-7.7-38.8-36-38.8-36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.4 310c-1.1-3.6 5.8-17.6 5.8-17.6l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4l-1.3-.6-1.3 21s2 20.2 25 16.4c9.4-1.6 19.4-10 28-19.4-8.8-1.6-22-5-23-7.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M231.7 305c-1.5 1.8-3.7-2-8.8-4.5-3.3-1.6-8.4-3-12.7-4.7l-3.8-8.9c-1.9-4-4.8-1.4-4.8-1.4a21 21 0 0 1-3.7-5.9c-1.8-4-4.8-3.7-8.8-4.4s-12.5-8.4-12.5-8.4-4-3-5.5-4.5a31 31 0 0 1-16.3 14.4c15.6 16.4 47.5 47.5 50.8 49.9 3.7 2.5 2.6 9.9 0 17.2s-12 18-11.7 29.7 4 29.8 3.6 33.4a68 68 0 0 1-9.2 15.7l3.7.5h19.5c-.2-9.9-.1-50 6.6-66a317 317 0 0 0 13.6-52.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M232 303.6s-4.6-1.4-7.4 1.1-7 15-9.5 28.8a38 38 0 0 0 3 23.5s5.8-15.1 7.5-22.5 6.3-30.9 6.3-30.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M239.9 423h42.8s-11.8-15-11.8-20 16.2-71 16.9-75.7-2.2-8-8-8.4-28.3-5.2-29.4-8.8c0 0-8.5 29.7-11.4 49.8-2.5 17.4.1 53.3.9 63.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.4 310S239 346 239 360c0 0 16-19.5 18.2-33.2s-6.8-16.7-6.8-16.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M371.2 416.3s8.3.3 13.8 1.1a99 99 0 0 0 10.9.9s-3-6-6.2-7.8-9-4.8-13.9-4-11.8 5.5-11.2 7 3.1 2.3 6.6 2.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M385 413.8s6.6-3.4 8.2-3.4 12.5 7.5 12 8.7a3 3 0 0 1-3.4 1.2l-8.6-3.7-4.8 1.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M380.3 408.2s8.8-.3 10.5.6 9.6 14.4 8.4 15.3-4.4.7-4.3-.4-7.2-8.3-7.2-8.3l-5.8-1.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M375.1 406.4s8.9-.3 10.6.6 9.8 14.5 8.6 15.5-4.5.7-4.4-.4-7.3-8.4-7.3-8.4l-5.8-1.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M274.3 355.6c6.4 9.9 19.3 35 23 37.7 6 4.4 45.1 15.1 49 18s3.4 5.9 7 7 17 4.1 22.1 4.6 2.9-2.7 2.9-2.7l-8.8-6 7.7-1.9s7.6 9.2 9 9.7 4 0 3.8-1.1c-.3-1.8-8.4-16.7-11.3-17.3s-20.4 1.8-20.4 1.8-36.8-24.8-37.5-25.7c0 0-2.2-6.2-4-8.8s-3-1.8-3-1.8.8-3.3-.3-4.4l-5.9-5.9-.2.3q-1.5-3-3-6.9c-3.1-7.2-14-27.5-15.8-30.4-1.4-2.2-12.9-3.8-18.7-4.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M346.2 411.4c3.8 2.9 3.6 5.8 7.1 6.9s17 4.1 22.2 4.6 2.8-2.7 2.8-2.7l-8.7-6 7.6-1.9s7.6 9.2 9 9.7 4.2.7 3.8-1.1c-.7-3.5-8.4-16.6-11.3-17.3s-20.4 1.8-20.4 1.8L321 380a30 30 0 0 0-23.9 13.3l.1.1c6 4.4 45.1 15.1 49 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m257.9 236.7-30.2 12.6a44 44 0 0 1-3.8 15.3c-3.6 7.5-1.5 21.8 1.9 29.5s18.5 4.7 24 3.7a59 59 0 0 0 11-3.2 10 10 0 0 0 9.7-1.3s-16.1-45.3-12.6-56.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M158 417.4a18 18 0 0 1-6.3-1.5 2.2 2.2 0 1 1 1.7-4c2 .8 4.6 1.4 5.3 1 1.3-1.4 3.2-10 .7-14q-.9-1.3-1.5-1.2c-1.4-.2-3.5 1.3-4.3 2a2.2 2.2 0 1 1-3-3.2c.4-.4 4-3.6 7.9-3.1a6 6 0 0 1 4.6 3.2c3.7 6 1.1 17.5-1.7 19.8a5 5 0 0 1-3.4 1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M130.1 391.6h24.1v31.9h-24.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "i",
    fill: "#fff",
    d: "M371.2 416.3s8.3.3 13.8 1.1a99 99 0 0 0 10.9.9s-3-6-6.2-7.8-9-4.8-13.9-4-11.8 5.5-11.2 7 3.1 2.3 6.6 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    fill: "#fff",
    d: "M380.3 408.2s8.8-.3 10.5.6 9.6 14.4 8.4 15.3-4.4.7-4.3-.4-7.2-8.3-7.2-8.3l-5.8-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    fill: "#fff",
    d: "M375.1 406.4s8.9-.3 10.6.6 9.8 14.5 8.6 15.5-4.5.7-4.4-.4-7.3-8.4-7.3-8.4l-5.8-1.3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M440.7 263.8c2-26.6-4.2-54.4-12.5-79-12.2-36.8-36.1-74.5-76.3-83.2-23.2-5-46.8.4-66.7 13-19 12-34 27.6-57.5 30.7-23.7 3-48.1 1.8-72 1.8-61.5 0-111.3 64.5-98.8 131.7s71.2 113.9 121 113.9c44.8 0 81.7-26.9 124.2-34.1 21.1-3.6 42.3.6 63.2-4.7a101 101 0 0 0 60.5-42.7 103 103 0 0 0 15-47.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M440.7 263.8c2-26.6-4.2-54.4-12.5-79-12.2-36.8-36.1-74.5-76.3-83.2-23.2-5-46.8.4-66.7 13-19 12-34 27.6-57.5 30.7-23.7 3-48.1 1.8-72 1.8-61.5 0-111.3 64.5-98.8 131.7s71.2 113.9 121 113.9c44.8 0 81.7-26.9 124.2-34.1 21.1-3.6 42.3.6 63.2-4.7a101 101 0 0 0 60.5-42.7 103 103 0 0 0 15-47.4",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M433.5 254.4s0-5-7-11.9-11.4-11-11.4-11-3.5 11.5 3 18.5a123 123 0 0 0 15.4 13.4Zm-10.1 31.1s0-5-7-12-11.4-10.9-11.4-10.9-3.5 11.4 3 18.4a123 123 0 0 0 15.4 13.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M433 262.9s.6-5 8.3-11.1l12.5-9.7s2.2 11.7-5 18a123 123 0 0 1-16.7 11.7Zm-12.1 36.7s1-4.9 9.3-10.2 13.5-8.3 13.5-8.3 1 11.9-6.8 17.3a123 123 0 0 1-17.9 10Zm2.3 40s0-5 7-12 11.4-10.9 11.4-10.9 3.5 11.4-3 18.4a122 122 0 0 1-15.4 13.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M423 349.3s.8-4.9-5.1-12.8-9.8-12.4-9.8-12.4-5 10.8.3 18.6a122 122 0 0 0 13.4 15.5Zm-6.8 29s0-5 7-12 11.4-11 11.4-11 3.5 11.5-3 18.5a123 123 0 0 1-15.4 13.4Zm4.6 26.2s-1.2-4.8 3.7-13.3 8.3-13.5 8.3-13.5 6.3 10.2 1.8 18.6a122 122 0 0 1-11.5 16.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M434.2 253.2a142 142 0 0 1-2 15.4c-2.7 14.2-9.6 23.4-12.3 36.2s5.1 29.4 3 46-8.6 25.6-6.7 36.6 11.4 40.8 11.4 40.8m5.4-162 7.5-5.8m-7.1-.8-3.2-5.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m420.3 304.3 12.7-9.5m-9.6-.4s-5.2-10.2-11.1-17m11.1 69.3a78 78 0 0 1 13.5-18m-14.7 24.9a87 87 0 0 0-6.8-12.9l-4.2-6m5 52.7a84 84 0 0 1 5.7-11.4 73 73 0 0 1 7.3-9.6m-6.1 46.8a21 21 0 0 1 1.9-11c2.6-5.1 5.6-11.7 6.8-14.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M376.7 320.9s-.5-3.1 3-8.3 6-8 6-8 3.5 6.7.2 11.8a78 78 0 0 1-8.2 10Zm9.7 18.4s-.5-3.2 3-8.3 6-8 6-8 3.5 6.7.2 11.8a79 79 0 0 1-8.2 10Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M377.9 326.1s-.9-3-6.3-6-9-4.8-9-4.8 0 7.7 5 10.8a78 78 0 0 0 11.8 5.5Zm11.6 21.7s-1.2-3-7-5.4l-9.3-3.7s.7 7.6 6.2 10.1a78 78 0 0 0 12.3 4.3Zm2.9 25.4s-.5-3.2-5.6-6.8-8.4-5.6-8.4-5.6-1 7.5 3.9 11.2a77 77 0 0 0 11.1 6.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M393.6 379.3s-1-3 1.8-8.6 4.8-9 4.8-9 4.4 6.3 1.8 11.8a78 78 0 0 1-6.7 11.2Zm8.7 25.1s.4-3.1 5.3-7 8-6 8-6 1.3 7.4-3.2 11.3a78 78 0 0 1-10.8 7.4Zm-1.3-7.7s-.5-3.2-5.7-6.8l-8.3-5.6s-1 7.6 3.9 11.2a78 78 0 0 0 11.1 6.8Zm0 16.9s.3-3.2-3.8-8l-6.6-7.5s-2.9 7 .9 11.8a78 78 0 0 0 9 9.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M376.2 320.1a90 90 0 0 0 2.8 9.5c3.3 8.6 8.6 13.6 11.7 21.4s0 19 3.1 29.1 8.2 15.2 8.2 22.3-2.8 26.8-2.8 26.8m-20.9-101-5.3-2.8m4.4-1.3 1.3-3.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m390.4 350.7-9-4.5m6-1.3a64 64 0 0 1 5.1-11.9m.5 44.6a50 50 0 0 0-10.3-9.8m11.9 14.1a56 56 0 0 1 2.8-8.9l2-4.3m2.4 39.1a47 47 0 0 1 5.7-6l3.7-3.2m-9.2 3.8a54 54 0 0 0-4.8-6.6 47 47 0 0 0-5.6-5.2m8.9 28.7a14 14 0 0 0-2.4-6.7l-5.8-8.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "m92.7 277.3-4.4-12.5 4.4 5.3-3.5-18.8 5.3 13.5 1.9-26.3 3.2 25.1 3.4-5v6.2l4.1-8.4-2.2 14.7 3.7-2.5-5.9 8.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M106.4 274.2H90.2l2.9 32.8h10.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M81.5 306.7h55.4v117.4H81.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 306.7H140v117.4h-30.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 306.7h27.3v117.4h-27.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 396.8h24.2v24h-24.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 398.1h24.2v3.1h-24.2zm0 17.7h24.2v3.1h-24.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M113.8 397.3v30.4m8.5-30.4v30.4m7.4-30.4v30.4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 311h24.2v35.4h-24.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 312.5h24.2v3.5h-24.2zm0 22.7h24.2v3.5h-24.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M113.8 311.6v34.5m8.5-34.5v34.5m7.4-34.5v34.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 353.6h24.2V389h-24.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 355.1h24.2v3.5h-24.2zm0 22.7h24.2v3.5h-24.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M113.8 354.2v34.5m8.5-34.5v34.5m7.4-34.5v34.5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 345.9h27.7v4h-27.7zm0 42.9h27.7v4h-27.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M136.9 306.7v117.4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M105.3 306.7v117.4h3.9V311h27.3v-4.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M109.2 311v-4.3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.7 252.7c-2.9-5.6-4-9.6-4-10.5 0-1.9 4-3 4-3 6.2-3.3 35.5 1.5 48.7 3.7a151 151 0 0 0 22.4 2.2s1.8-1.5 4-3.3 12.5-14 16.5-15 7.7 1.5 7.7 1.5 6.6 4 5.5 4.7-17.2 14.7-21.3 17.3-12.4 1.5-19.8 3c-6.3 1.2-32 2.7-37.8 3.2a21 21 0 0 1-13.2-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M236 228.2s-3.6-2.5-7.6-1.4-14.3 13.2-16.5 15l-4 3.3a151 151 0 0 1-22.4-2.2c-13.2-2.2-42.6-7-48.8-3.7 0 0-4 1.1-4 3l.8 3 .5.1s7.4-.7 23.2-.3 52.4 2.5 54.7 3.4c1 .3 8.1-1.3 16-4l13.7-11.5c1-.6-5.5-4.7-5.5-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M236 228.2s-3.6-2.5-7.6-1.4-14.3 13.2-16.5 15l-4 3.3a151 151 0 0 1-22.4-2.2c-13.2-2.2-42.6-7-48.8-3.7 0 0-4 1.1-4 3l.8 3 .5.1s7.4-.7 23.2-.3 52.4 2.5 54.7 3.4c1 .3 8.1-1.3 16-4l13.7-11.5c1-.6-5.5-4.7-5.5-4.7",
    opacity: 0.5
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M136.7 252.7c-2.9-5.6-4-9.6-4-10.5 0-1.9 4-3 4-3 6.2-3.3 35.5 1.5 48.7 3.7a151 151 0 0 0 22.4 2.2s1.8-1.5 4-3.3 12.5-14 16.5-15 7.7 1.5 7.7 1.5 6.6 4 5.5 4.7-17.2 14.7-21.3 17.3-12.4 1.5-19.8 3c-6.3 1.2-32 2.7-37.8 3.2a21 21 0 0 1-13.2-1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M281.7 285.4a8 8 0 0 1 6.9-4.2h66.7s4.8 0 3.3 9.2-21.2 65-26 82-5.7 52.5-5.7 52.5h-80s6.3-85.2 34.7-139.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.7 281.2h-23.1a8 8 0 0 0-7 4.2c-28.4 54.3-34.8 139.5-34.8 139.5h35.9l8.8-33.6 37 7.6.8-8.5-.8-9s-7.5-8-10-10-.7-5.6-1.1-21-14.3-26.7-19.5-36.3 2.8-15.5 10-25a19 19 0 0 0 3.8-8",
    opacity: 0.2
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M281.7 285.4a8 8 0 0 1 6.9-4.2h66.7s4.8 0 3.3 9.2-21.2 65-26 82-5.7 52.5-5.7 52.5h-80s6.3-85.2 34.7-139.5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M343.7 297.1c-6.7 15.7-21 78-23.3 127.8h6.4s1-35.7 5.8-52.6 24.6-72.8 26-82-3.4-9.1-3.4-9.1-6 3.3-11.5 15.9m-117.2-31.4s-10.6-6.3-14.6-17.3 31.5-28.6 47-29.7 19.8 3 29 18.7 15.4 37.4 10.6 48-12.8 13.3-7 22 22.4 33.8 21.3 45.6-12.5 22-29 23-38.6-8.7-56.9-25-13.6-40-7-47.6 16.5-10.7 17.2-18.4-10.6-19.3-10.6-19.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M271.9 248.3a190 190 0 0 1 15 33c3.8 15-16 24.3-10.6 31.5m-12.1-78.3 5.2 9.2m24.4 17.3a27 27 0 0 1 1.3 6M268 229s17.4 12.8 24.3 28.2m-48.4-18.6c-12.4 3.5-30.3 9.2-28.8 12.4m40.3-15.4-6.7 1.7M240 229a64 64 0 0 1 22-2.8m-27 5 3.4-1.6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.6 242.2v.2zm4.1 10.5a48 48 0 0 1-4-9.7 48 48 0 0 0 4 9.7m-4-10.2v.2zm0 .2v.3zm4 10a92 92 0 0 0 13.9 19.6c13.2 14.3 51.4 51.7 55 54.3s2.6 9.9 0 17.2-12.1 18-11.8 29.7 4 29.7 3.7 33.4-9.5 16.2-9.5 16.2h94.7s-11.8-15-11.8-20.2 16.2-70.8 16.9-75.6-2.2-8-8-8.4-28.3-5.2-29.4-8.8 5.8-17.7 5.8-17.7l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4-15-4.7-18.8-7.7-38.8-36-38.8-36"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "m209.8 295.6 3.6 6.1s6.2 3.5 7.7 3.5 10.8 5 10.8 5 7.8-2 5-8.5a21 21 0 0 0-3.2-4.6c-.4 2.9-1.2 6.7-2 7.8-1.5 1.8-3.7-1.8-8.9-4.4-3.3-1.7-8.7-3.2-13-4.9M191 280.8c-11.4-10.5-25.7-24-25.7-24l-8.4-1.1-1 .5s23.6 20.8 28.6 23.2a16 16 0 0 0 6.4 1.4m11.9 10.9-.9-.9.7 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m209.8 295.6 3.6 6.1s6.2 3.5 7.7 3.5 10.8 5 10.8 5 7.8-2 5-8.5a21 21 0 0 0-3.2-4.6c-.4 2.9-1.2 6.7-2 7.8-1.5 1.8-3.7-1.8-8.9-4.4-3.3-1.7-8.7-3.2-13-4.9M191 280.8c-11.4-10.5-25.7-24-25.7-24l-8.4-1.1-1 .5s23.6 20.8 28.6 23.2a16 16 0 0 0 6.4 1.4m11.9 10.9-.9-.9.7 1.3Z",
    opacity: 0.5
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M132.6 242.2v.2zm4.1 10.5a48 48 0 0 1-4-9.7 48 48 0 0 0 4 9.7m-4-10.2v.2zm0 .2v.3zm4 10a92 92 0 0 0 13.9 19.6c13.2 14.3 51.4 51.7 55 54.3s2.6 9.9 0 17.2-12.1 18-11.8 29.7 4 29.7 3.7 33.4-9.5 16.2-9.5 16.2h94.7s-11.8-15-11.8-20.2 16.2-70.8 16.9-75.6-2.2-8-8-8.4-28.3-5.2-29.4-8.8 5.8-17.7 5.8-17.7l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4-15-4.7-18.8-7.7-38.8-36-38.8-36"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M165.3 256.9s-11.8.2-18.3-5.2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250.4 310c-1.1-3.6 5.8-17.6 5.8-17.6l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4l-1.3-.6-1.3 21s2 20.2 25 16.4c9.4-1.6 19.4-10 28-19.4-8.8-1.6-22-5-23-7.8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M249.8 295.2s-1.4 7.5-2.4 15.7l-1.9 14.4 4.9-15.3 5.5-16.1s-5.3 0-6.1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M249.8 295.2s-1.4 7.5-2.4 15.7l-1.9 14.4 4.9-15.3 5.5-16.1s-5.3 0-6.1 1.3",
    opacity: 0.5
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.4 310c-1.1-3.6 5.8-17.6 5.8-17.6l-22 1.1s-1 9.6-2.5 11.4-3.7-1.8-8.8-4.4l-1.3-.6-1.3 21s2 20.2 25 16.4c9.4-1.6 19.4-10 28-19.4-8.8-1.6-22-5-23-7.8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M231.7 305c-1.5 1.8-3.7-2-8.8-4.5-3.3-1.6-8.4-3-12.7-4.7l-3.8-8.9c-1.9-4-4.8-1.4-4.8-1.4a21 21 0 0 1-3.7-5.9c-1.8-4-4.8-3.7-8.8-4.4s-12.5-8.4-12.5-8.4-4-3-5.5-4.5a31 31 0 0 1-16.3 14.4c15.6 16.4 47.5 47.5 50.8 49.9 3.7 2.5 2.6 9.9 0 17.2s-12 18-11.7 29.7 4 29.8 3.6 33.4a68 68 0 0 1-9.2 15.7l3.7.5h19.5c-.2-9.9-.1-50 6.6-66a317 317 0 0 0 13.6-52.2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.9 300.5c-3.3-1.6-8.4-3-12.7-4.7l-3.8-8.9c-1.9-4-4.8-1.4-4.8-1.4a21 21 0 0 1-3.7-5.9c-1.8-4-4.8-3.7-8.8-4.4s-12.5-8.4-12.5-8.4-4-3-5.5-4.5a27 27 0 0 1-3 4.5c6.6 5.5 13.9 11.4 16.4 12.6 5 2.3 6.2.3 10 2.7s8 10 8 10 2.4-6.2 4.3-2 6.6 11.6 6.6 11.6 6.2 3.5 7.7 3.5c1.2 0 7.2 3 9.7 4.4l.8-4.7c-1.4 1.9-3.6-1.8-8.7-4.4",
    opacity: 0.2
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M231.7 305c-1.5 1.8-3.7-2-8.8-4.5-3.3-1.6-8.4-3-12.7-4.7l-3.8-8.9c-1.9-4-4.8-1.4-4.8-1.4a21 21 0 0 1-3.7-5.9c-1.8-4-4.8-3.7-8.8-4.4s-12.5-8.4-12.5-8.4-4-3-5.5-4.5a31 31 0 0 1-16.3 14.4c15.6 16.4 47.5 47.5 50.8 49.9 3.7 2.5 2.6 9.9 0 17.2s-12 18-11.7 29.7 4 29.8 3.6 33.4a68 68 0 0 1-9.2 15.7l3.7.5h19.5c-.2-9.9-.1-50 6.6-66a317 317 0 0 0 13.6-52.2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M232 303.6s-4.6-1.4-7.4 1.1-7 15-9.5 28.8a38 38 0 0 0 3 23.5s5.8-15.1 7.5-22.5 6.3-30.9 6.3-30.9"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.2 305.9s3.3-.8 4.6-.4a13 13 0 0 1 3.2 2l1-3.9a7 7 0 0 0-4.5-.7c-2.3.5-4.3 3-4.3 3",
    opacity: 0.2
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M232 303.6s-4.6-1.4-7.4 1.1-7 15-9.5 28.8a38 38 0 0 0 3 23.5s5.8-15.1 7.5-22.5 6.3-30.9 6.3-30.9m-30.7 1.2 5.9 23.9-13.2-30.1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M239.9 423h42.8s-11.8-15-11.8-20 16.2-71 16.9-75.7-2.2-8-8-8.4-28.3-5.2-29.4-8.8c0 0-8.5 29.7-11.4 49.8-2.5 17.4.1 53.3.9 63.2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.7 318.9c-4.8-.3-20.7-3.6-26.9-6.8l2.3 5.2a45 45 0 0 0 13 4.5c7.4 1.4 14.4 1.1 18.9 7.8l.2.3.6-2.6c.7-4.8-2.2-8-8-8.4",
    opacity: 0.2
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M239.9 423h42.8s-11.8-15-11.8-20 16.2-71 16.9-75.7-2.2-8-8-8.4-28.3-5.2-29.4-8.8c0 0-8.5 29.7-11.4 49.8-2.5 17.4.1 53.3.9 63.2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M250.4 310S239 346 239 360c0 0 16-19.5 18.2-33.2s-6.8-16.7-6.8-16.7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.4 314.7a11 11 0 0 1 8.8 4.2s-2.2-6.5-6.8-8.9Z",
    opacity: 0.2
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M250.4 310S239 346 239 360c0 0 16-19.5 18.2-33.2s-6.8-16.7-6.8-16.7"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#i"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M371.2 416.3s8.3.3 13.8 1.1a99 99 0 0 0 10.9.9s-3-6-6.2-7.8-9-4.8-13.9-4-11.8 5.5-11.2 7 3.1 2.3 6.6 2.8"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i",
    opacity: 0.5
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M371.2 416.3s8.3.3 13.8 1.1a99 99 0 0 0 10.9.9s-3-6-6.2-7.8-9-4.8-13.9-4-11.8 5.5-11.2 7 3.1 2.3 6.6 2.8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385 413.8s6.6-3.4 8.2-3.4 12.5 7.5 12 8.7a3 3 0 0 1-3.4 1.2l-8.6-3.7-4.8 1.2Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M385 413.8s6.6-3.4 8.2-3.4 12.5 7.5 12 8.7-3.1 2-3.4 1.2-8.6-3.7-8.6-3.7l-4.8 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385 413.8s6.6-3.4 8.2-3.4 12.5 7.5 12 8.7-3.1 2-3.4 1.2-8.6-3.7-8.6-3.7l-4.8 1.2Z",
    opacity: 0.5
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M385 413.8s6.6-3.4 8.2-3.4 12.5 7.5 12 8.7a3 3 0 0 1-3.4 1.2l-8.6-3.7-4.8 1.2Z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#l"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M380.3 408.2s8.8-.3 10.5.6 9.6 14.4 8.4 15.3-4.4.7-4.3-.4-7.2-8.3-7.2-8.3l-5.8-1.2Z"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#l",
    opacity: 0.5
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M380.3 408.2s8.8-.3 10.5.6 9.6 14.4 8.4 15.3-4.4.7-4.3-.4-7.2-8.3-7.2-8.3l-5.8-1.2Z"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#n"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M375.1 406.4s8.9-.3 10.6.6 9.8 14.5 8.6 15.5-4.5.7-4.4-.4-7.3-8.4-7.3-8.4l-5.8-1.3Z"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#n",
    opacity: 0.5
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M375.1 406.4s8.9-.3 10.6.6 9.8 14.5 8.6 15.5-4.5.7-4.4-.4-7.3-8.4-7.3-8.4l-5.8-1.3Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M274.3 355.6c6.4 9.9 19.3 35 23 37.7 6 4.4 45.1 15.1 49 18s3.4 5.9 7 7 17 4.1 22.1 4.6 2.9-2.7 2.9-2.7l-8.8-6 7.7-1.9s7.6 9.2 9 9.7 4 0 3.8-1.1c-.3-1.8-8.4-16.7-11.3-17.3s-20.4 1.8-20.4 1.8-36.8-24.8-37.5-25.7c0 0-2.2-6.2-4-8.8s-3-1.8-3-1.8.8-3.3-.3-4.4l-5.9-5.9-.2.3q-1.5-3-3-6.9c-3.1-7.2-14-27.5-15.8-30.4-1.4-2.2-12.9-3.8-18.7-4.5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.8 356.2c4.8 4.3 3.2 4.3 2.2 8s.8-1.3 5.3-1 3.2 6 2.6 7.1 5.7 2.4 4.6 4.8-7.2 5.9-10.7 9.3 9-5.5 13.3-5.8h3.3a42 42 0 0 0-3.6-7.6c-1.9-2.6-3-1.9-3-1.9s.8-3.3-.3-4.4l-5.9-5.8-.2.2q-1.5-3-3-6.8c-3.2-7.3-14-27.6-15.9-30.5-1.3-2.2-12.8-3.8-18.6-4.4l.5 4.6.1.1 9.6 1.6c2.4.3 5.3 2.4 5 4s-7.1 8.8-5 9.3 4.5-5.3 7-4.5 7.9 19.4 12.7 23.7",
    opacity: 0.2
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M274.3 355.6c6.4 9.9 19.3 35 23 37.7 6 4.4 45.1 15.1 49 18s3.4 5.9 7 7 17 4.1 22.1 4.6 2.9-2.7 2.9-2.7l-8.8-6 7.7-1.9s7.6 9.2 9 9.7 4 0 3.8-1.1c-.3-1.8-8.4-16.7-11.3-17.3s-20.4 1.8-20.4 1.8-36.8-24.8-37.5-25.7c0 0-2.2-6.2-4-8.8s-3-1.8-3-1.8.8-3.3-.3-4.4l-5.9-5.9-.2.3q-1.5-3-3-6.9c-3.1-7.2-14-27.5-15.8-30.4-1.4-2.2-12.9-3.8-18.7-4.5m4.5 24.7-.7 2.7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M284 325.5a54 54 0 0 0-7.8 11.8m22.6 44.9c2.7-4 7-9 11.7-10.5m-14.7 15.5 1.3-2.4m-1.3-4s4.9-12.3 9.8-15.4 2.1 3.2 2.1 3.2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.2 411.4c3.8 2.9 3.6 5.8 7.1 6.9s17 4.1 22.2 4.6 2.8-2.7 2.8-2.7l-8.7-6 7.6-1.9s7.6 9.2 9 9.7 4.2.7 3.8-1.1c-.7-3.5-8.4-16.6-11.3-17.3s-20.4 1.8-20.4 1.8L321 380a30 30 0 0 0-23.9 13.3l.1.1c6 4.4 45.1 15.1 49 18"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M390 421c-1.8-4.5-8.4-16.7-11.3-17.3s-20.4 1.8-20.4 1.8L321 380a37 37 0 0 0-10.9 2.6c5.3 3 40.6 23 45 23.9 4.7 1 20.5-1.6 23.2.3 1.8 1.1 7 9.4 10.6 15.3q1.6 0 1-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M390 421c-2.8-6.5-8.4-16.7-11.3-17.3s-20.4 1.8-20.4 1.8L321 380a37 37 0 0 0-10.9 2.6c5.3 3 40.6 23 45 23.9 4.7 1 20.5-1.6 23.2.3 1.8 1.1 7 9.4 10.6 15.3q1.6 0 1-1.2",
    opacity: 0.5
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M346.2 411.4c3.8 2.9 3.6 5.8 7.1 6.9s17 4.1 22.2 4.6 2.8-2.7 2.8-2.7l-8.7-6 7.6-1.9s7.6 9.2 9 9.7 4.2.7 3.8-1.1c-.7-3.5-8.4-16.6-11.3-17.3s-20.4 1.8-20.4 1.8L321 380a30 30 0 0 0-23.9 13.3l.1.1c6 4.4 45.1 15.1 49 18"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m257.9 236.7-30.2 12.6a44 44 0 0 1-3.8 15.3c-3.6 7.5-1.5 21.8 1.9 29.5s18.5 4.7 24 3.7a59 59 0 0 0 11-3.2 10 10 0 0 0 9.7-1.3s-16.1-45.3-12.6-56.6"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "m257.9 236.7-30.2 12.6a44 44 0 0 1-3.8 15.3c-3.6 7.5-1.5 21.8 1.9 29.5a7 7 0 0 0 2.6 3v-.6s-5.5-13.8-4.5-21.8 5.6-12 6.1-17 .3-7.5 10.4-11.3 14.4-7.2 15.5-3.4 5.3 28.2 8.2 34 2.7 12-1.8 14.7a64 64 0 0 1-14.6 6.4l2.1-.3a59 59 0 0 0 11-3.2 10 10 0 0 0 9.7-1.4S254.4 248 258 236.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m257.9 236.7-30.2 12.6a44 44 0 0 1-3.8 15.3c-3.6 7.5-1.5 21.8 1.9 29.5a7 7 0 0 0 2.6 3v-.6s-5.5-13.8-4.5-21.8 5.6-12 6.1-17 .3-7.5 10.4-11.3 14.4-7.2 15.5-3.4 5.3 28.2 8.2 34 2.7 12-1.8 14.7a64 64 0 0 1-14.6 6.4l2.1-.3a59 59 0 0 0 11-3.2 10 10 0 0 0 9.7-1.4S254.4 248 258 236.7",
    opacity: 0.5
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m257.9 236.7-30.2 12.6a44 44 0 0 1-3.8 15.3c-3.6 7.5-1.5 21.8 1.9 29.5s18.5 4.7 24 3.7a59 59 0 0 0 11-3.2 10 10 0 0 0 9.7-1.3s-16.1-45.3-12.6-56.6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M242.6 256.4a16 16 0 0 1-.6 5.3c-.8 2-8.4 9.8-8.1 10.7s.9 3.6 2.2 3.8m14.9-12.7c1-2.1 4.5 0 4.5 4.7m-21.6-10.9s3-1.3 5.6 3.5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M246.8 270.4a15 15 0 0 1 9.1 3.8m-25.5-10a19 19 0 0 1 5 1.4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M242.3 252a6 6 0 0 0-5-.1c-2.8 1.3-4.4 2.7-4.2 1s3.3-3.4 4.3-3.7 5.2-.9 4.9 2.8m7.5-3.7a23 23 0 0 1 6.5 8.4c2 5 3.6-.4 2-3.7s-6.1-6.7-8.5-4.7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M271 301.8c0 2.3-1.4 4.2-3 4.2s-3-1.9-3-4.2 1.4-8.3 3-8.3 3 6 3 8.3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m251.3 262.6-.3.9c-.3 1.5-.6 4.6 0 4.7s2-2.8 2.2-4.2l.1-1zm-17.1-5.6-.2.8c-.3 1.5-.3 4.7.3 4.9s1.7-3 2-4.4l.1-1.1a6 6 0 0 0-2.2-.2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m251 263.5 1-1.8a7 7 0 0 1 4 2.3m-21.8-7 1-1.2s.4-.2 2.8.9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M230.4 284.1s1.7-3 4-3 3.9 5 3.9 5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158 417.4a18 18 0 0 1-6.3-1.5 2.2 2.2 0 1 1 1.7-4c2 .8 4.6 1.4 5.3 1 1.3-1.4 3.2-10 .7-14q-.9-1.3-1.5-1.2c-1.4-.2-3.5 1.3-4.3 2a2.2 2.2 0 1 1-3-3.2c.4-.4 4-3.6 7.9-3.1a6 6 0 0 1 4.6 3.2c3.7 6 1.1 17.5-1.7 19.8a5 5 0 0 1-3.4 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M161 398.2a4 4 0 0 0-3-2.5c-2.6-.4-5 2.1-5.2 2.4a2 2 0 0 0-.2 2.1l1-.5c.8-.7 3-2.2 4.4-2q.5-.1 1.4 1c2.5 4.2.6 12.8-.7 14.2-.7.3-3.3-.2-5.3-1l-.7-.2a2 2 0 0 0 .8 1.3 10 10 0 0 0 4 1.2 3 3 0 0 0 2.3-.8c1.9-1.7 3.5-10.6 1.1-15.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161 398.2a4 4 0 0 0-3-2.5c-2.6-.4-5 2.1-5.2 2.4a2 2 0 0 0-.2 2.1l1-.5c.8-.7 3-2.2 4.4-2q.5-.1 1.4 1c2.5 4.2.6 12.8-.7 14.2-.7.3-3.3-.2-5.3-1l-.7-.2a2 2 0 0 0 .8 1.3 10 10 0 0 0 4 1.2 3 3 0 0 0 2.3-.8c1.9-1.7 3.5-10.6 1.1-15.2",
    opacity: 0.5
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M158 417.4a18 18 0 0 1-6.3-1.5 2.2 2.2 0 1 1 1.7-4c2 .8 4.6 1.4 5.3 1 1.3-1.4 3.2-10 .7-14q-.9-1.3-1.5-1.2c-1.4-.2-3.5 1.3-4.3 2a2.2 2.2 0 1 1-3-3.2c.4-.4 4-3.6 7.9-3.1a6 6 0 0 1 4.6 3.2c3.7 6 1.1 17.5-1.7 19.8a5 5 0 0 1-3.4 1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.1 391.6h24.1v31.9h-24.1z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#041147",
    d: "M130.1 391.6h9.8v31.9h-9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.1 391.6h9.8v31.9h-9.8z",
    opacity: 0.5
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M130.1 391.6h24.1v31.9h-24.1z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    d: "M286.3 423H183.6l-3.3-56.4a3.8 3.8 0 0 1 3.7-4.5h101.9a3.8 3.8 0 0 1 3.8 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    d: "M188.7 363.5h96.5a3.7 3.7 0 0 1 3.7 4.3m-107.9-.9a4 4 0 0 1 3.8-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    d: "M183.2 417.6h103.6v5.5H183.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.6,
    cy: 392.8,
    fill: "#fff",
    stroke: "#263238",
    rx: 7.3,
    ry: 4.4
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M57.2 422.4h385.9v9.4H57.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208.3,
    height: 129.2,
    x: 146,
    y: 75,
    fill: "#041147",
    rx: 11.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250.2,
    cy: 118.8,
    r: 30.9,
    fill: "#263238",
    transform: "rotate(-9.1 250.1 118.7)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m250 124.5-10.4 13.2a4 4 0 0 1-3.2 1.8 3 3 0 0 1-2.4-1 3 3 0 0 1-1-2.3 5 5 0 0 1 1-2.8l11.7-14.5-11-14.5a4 4 0 0 1-.8-2.4 4 4 0 0 1 1.2-2.7 4 4 0 0 1 2.7-1.1 4 4 0 0 1 3.2 1.8l10 13 10-12.8a4 4 0 0 1 3.4-2 3 3 0 0 1 2.3 1 3 3 0 0 1 1 2.3 4 4 0 0 1-.8 2l-11.7 15.2 11.3 15a4 4 0 0 1 .9 2.3 3 3 0 0 1-1.2 2.6 4 4 0 0 1-2.7 1.1 4 4 0 0 1-3.3-1.8Zm59 57.3H191.3a9 9 0 0 1-9-9 9 9 0 0 1 9-9H309a9 9 0 0 1 9 9 9 9 0 0 1-9 9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m207.4 175.7-.4-.2-.2-.4.1-.4 1-1.4h-2l-.4-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.8-1.3-.1-.4.1-.5.5-.2.5.4.9 1.5.8-1.5.6-.4.5.2.1.4v.4l-1 1.5 1.9-.1.4.2v.8l-.4.2h-1.9l.8 1.3.2.5-.2.5-.4.1-.6-.4-.8-1.4-.8 1.4zm9.2 0-.4-.2-.2-.4.1-.4 1-1.4h-2l-.4-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.4-.1-.4.2-.4.4-.2.5.3 1 1.6.8-1.5.6-.4.4.2.2.4-.2.4-.8 1.4h1.8l.5.1a1 1 0 0 1 0 .9l-.5.2H219l.9 1.2.1.6-.2.4-.4.2-.5-.4-.9-1.5-.8 1.5zm9.2 0-.4-.2-.2-.4v-.4l1-1.4h-1.8l-.5-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.4-.1-.4.2-.4.4-.2.5.3.9 1.6.8-1.5.6-.4.5.2.1.4v.4l-1 1.4h1.9l.4.1a1 1 0 0 1 0 .9l-.4.2h-1.9l.8 1.2.2.6-.2.4-.4.2-.6-.4-.8-1.5-.8 1.5zm9.2 0-.4-.2-.2-.4.1-.4 1-1.4h-2l-.4-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.4-.1-.4.2-.4.4-.2.5.3 1 1.6.8-1.5.6-.4.4.2.2.4-.2.4-.8 1.4h1.8l.5.1a1 1 0 0 1 0 .9l-.5.2h-1.9l.9 1.2.1.6-.2.4-.4.2-.5-.4-.9-1.5-.8 1.5zm9.1 0-.4-.2-.2-.4.1-.4 1-1.4h-1.9l-.4-.2a1 1 0 0 1 0-.9l.4-.2 1.8.1-.8-1.4-.2-.4.2-.4.5-.2.5.3.9 1.6.8-1.5.6-.4.4.2.2.4-.1.4-.9 1.4h1.8l.5.1a1 1 0 0 1 0 .9l-.5.2h-1.8l.8 1.2.2.6-.2.4-.4.2-.6-.4-.8-1.5-.9 1.5zm9.2 0-.4-.2-.2-.4.1-.4 1-1.4h-1.9l-.5-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.8-1.4-.2-.4.2-.4.4-.2.6.3.8 1.6.9-1.5.6-.4.4.2.2.4-.1.4-1 1.4h2l.4.1a1 1 0 0 1 0 .9l-.5.2h-1.8l.8 1.2.1.6-.1.4-.4.2-.6-.4-.9-1.5-.8 1.5zm9.2 0-.4-.2-.2-.4.1-.4 1-1.4h-2l-.4-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.3-.1-.4.2-.5.4-.2.5.4.9 1.5.8-1.5.6-.4.4.2.2.4v.4l-1 1.5 1.9-.1.4.2v.8l-.4.2h-1.9l.8 1.3.2.5-.2.5-.4.1-.6-.4-.8-1.4-.8 1.4zm9.2 0-.4-.2-.2-.4v-.4l1-1.4h-1.8l-.5-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.4-.1-.4.6-.6.5.3.9 1.6.8-1.5.6-.4.5.2.1.4v.4l-1 1.4h1.9l.4.1a1 1 0 0 1 0 .9l-.4.2h-2l.8 1.2.2.6-.6.6-.6-.4-.8-1.5-.8 1.5-.6.4m9.3 0-.5-.2-.1-.4v-.4l1-1.4h-1.9l-.4-.2a1 1 0 0 1 0-.9l.4-.2 1.8.1-.8-1.4-.1-.4.6-.6.5.3.9 1.6.8-1.5.6-.4.4.2.2.4-.1.4-.9 1.4h1.8l.5.1a1 1 0 0 1 0 .9l-.5.2h-1.8l.8 1.2.2.6-.6.6-.6-.4-.8-1.5-.9 1.5zm9.1 0-.4-.2-.2-.4.1-.4 1-1.4h-2l-.4-.2a1 1 0 0 1 0-.9l.5-.2 1.8.1-.9-1.4-.1-.4.2-.4.4-.2.5.3 1 1.6.8-1.5.6-.4.4.2.2.4-.2.4-.8 1.4h1.8l.4.1a1 1 0 0 1 0 .9l-.4.2h-1.9l.9 1.2.1.6-.2.4-.4.2-.6-.4-.8-1.5-.8 1.5z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M321.5 197.8h12.2m-181.9-90V189a9 9 0 0 0 8.9 8.9h149.2M151.8 86.2v12.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgotPassword.5f33a60cb21c05380f2fe95603d57c86.svg";
export { ForwardRef as ReactComponent };